import gql from 'graphql-tag';
export default gql`
  mutation createOrUpdateProperty($applicationId: String!, $params: CreateOrUpdatePropertyInput) {
    createOrUpdateProperty(applicationId: $applicationId, params: $params) {
      status
      message
    }
  }
`;
